import axios from "axios";
import { API_BASE_URL } from "../config";

async function createPaymentIntent(amount) {
    
    const res = await fetch(`${API_BASE_URL}/payment/create-payment-intent`, {
        method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ amount: amount * 100 }) 
    });

    return res.json();
}

export {
    createPaymentIntent
}